import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { useSessionStore } from "../../../../Stores/SessionStore";
import FlashAccountPaymentCodeModal from "./FlashAccountPaymentCodeModal";

export default function FlashAccountPaymentsTable() {
	const store = useSessionStore();
	const [payments, setPayments] = useState([]);
	const [selectedPayment, setSelectedPayment] = useState(null);

	useEffect(() => {
		async function loadPayments() {
			if (!store?.Session?.Customer?.Id) {
				return;
			}

			const result = await store.RechargesService.GetFlashAccountPayments(store.Session.Customer.Id);
			if (result && result.Success) {
				setPayments(Array.isArray(result.Data) ? result.Data : []);
			}
		}

		loadPayments();
	}, [store]);

	return (
		<>
			<div className="portal-dashboard-card">
				<div className="portal-dashboard-card-header">
					<h4>Flash Payment Codes</h4>
				</div>
				<div className="portal-dashboard-card-body portal-purchase-history-body">
					<div className="portal-purchase-history-scroll">
						<Table className="portal-purchase-history-table mb-0">
							<thead>
								<tr>
									<th>Code</th>
									<th>Package</th>
								</tr>
							</thead>
							<tbody>
								{payments.length > 0 ? (
									payments.map((payment) => (
										<tr
											key={payment.Code}
											style={{ cursor: "pointer" }}
											onClick={() => setSelectedPayment(payment)}
										>
											<td>{payment.Code}</td>
											<td>{payment.Package ?? "—"}</td>
										</tr>
									))
								) : (
									<tr>
										<td colSpan={2} className="text-center">
											* No Flash payment codes yet *
										</td>
									</tr>
								)}
							</tbody>
						</Table>
					</div>
				</div>
			</div>
			<FlashAccountPaymentCodeModal
				show={selectedPayment != null}
				payment={selectedPayment}
				onClose={() => setSelectedPayment(null)}
			/>
		</>
	);
}
